import React from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { StyledCourseDetailHeaderBannerRatingStar } from './style';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';

type CourseReviewProps = {
  reviewAverageRating: number;
  totalReview: number;
};
const CourseReview = ({ reviewAverageRating, totalReview }: CourseReviewProps) => {
  const { t } = useTranslation('store_course');
  const theme = useTheme();

  const reviewStarStyle: React.CSSProperties = {
    fontSize: '16px',
    marginRight: '4px',
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <StyledCourseDetailHeaderBannerRatingStar
        name="rating"
        value={reviewAverageRating}
        readOnly
        icon={<FontAwesomeIcon icon="fa-solid fa-star" style={reviewStarStyle} />}
        emptyIcon={<FontAwesomeIcon icon="fa-regular fa-star" style={reviewStarStyle} />}
      />
      <Typography variant="body2_deprecated" color={theme.palette.textOnPrimary.secondary} sx={{ ml: '12px' }}>
        {t('course_detail.header_banner.review', {
          reviewAverageRating: reviewAverageRating.toFixed(1),
          totalReview,
        })}
      </Typography>
    </Box>
  );
};

export default CourseReview;
